import chalk from "chalk";
export default function healthCheck() {
    const healthCheckUrl = '/healthcheck';
    const healthCheckServicesUrl = `${healthCheckUrl}/services`;
    const services = fetch(healthCheckServicesUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });

    const serviceListElement = document.getElementById('service-list').querySelector('tbody');

    const statusElement = document.getElementById('check-status');
    if (statusElement) {
        statusElement.innerHTML = '<p class="text-gray-600">Status: <span class="text-yellow-600 font-bold">Processing...</span></p>';
    }
    const systemStatusElement = document.getElementById('system-status');

    let status = 'processing';

    services.then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    }).then(data => {
        if (statusElement) {
            statusElement.innerHTML = `<p class="text-gray-600">Running checks:</p>`;
            const checksList = document.createElement('ul');
            Object.entries(data).forEach(([key, value], index) => {
                const url = healthCheckUrl + '/' + value;

                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }).then(async res => {
                    if (serviceListElement) {
                        const response = await res.json();
                        const row = document.createElement('tr');
                        const serviceCell = document.createElement('td');
                        const serviceContent = document.createElement('div');
                        serviceContent.textContent = response.message || key;
                        serviceContent.classList.add('text-xs', 'font-medium', 'text-gray-500');
                        serviceCell.textContent = key;
                        serviceCell.classList.add('px-6', 'py-4', 'whitespace-nowrap', 'text-sm', 'text-gray-900');
                        serviceCell.appendChild(serviceContent);
                        row.appendChild(serviceCell);

                        const statusCell = document.createElement('td');
                        statusCell.textContent = response.status ? 'OK' : 'Failed';
                        statusCell.classList.add('px-6', 'py-4', 'whitespace-nowrap', 'text-sm', 'text-gray-900');
                        statusCell.classList.add(response.status ? 'text-green-600' : 'text-red-600', 'font-bold');
                        row.appendChild(statusCell);

                        serviceListElement.appendChild(row);

                        if (!response.status) {
                            status = 'error';
                        }
                    }
                }).then(() => {
                    if (status === 'processing') {
                        status = 'success';
                    }
                }).catch(err => {
                    status = 'error';
                });
            });
        }
    }).finally(async () => {
        await new Promise(resolve => setTimeout(resolve, 1000));
        if (status === 'error') {
            systemStatusElement.classList.remove('text-yellow-500', 'text-green-600');
            systemStatusElement.classList.add('text-red-600');
            systemStatusElement.innerHTML = `Error`;
        } else if (status === 'success') {
            systemStatusElement.classList.remove('text-yellow-500', 'text-red-600');
            systemStatusElement.classList.add('text-green-600');
            systemStatusElement.innerHTML = `OK`;
        }
    }).catch(error => {
        console.error(chalk.red('There was a problem with the fetch operation:'), error);
    });

    console.log(statusElement ? chalk.green('Health check completed successfully.') : chalk.red('Health check failed.'));
}